import React, { Component } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import FormData from 'yardformdata';
import Label from './label';
class SigCanvas extends Component {
    constructor(props) {
        super(props);
        this.url;
        var proxy = cb.rest.DynamicProxy.create({
            getFileServerUrl: {
                url: '/pub/fileupload/getFileServerUrl',
                method: 'GET',
                options: {
                    token: true
                }
            }
        });
        //获取服务器地址
        proxy.getFileServerUrl({}, function (err, result) {
            if (!err)
                this.url = result;
        }, this);
        this.state = {
            ...props,
            sigurl: '', //保存完整url，服务器地址+图片.jpg/png
            readOnly: false,
            sigWidth: 680
        }
    }

    componentWillMount() {
        /**
         * 判断是否需要更改宽度、是否指定画布占屏幕百分比
         * resizeMark: 是否需要更改宽度
         * resizeRate: 小数，表示画布占屏幕百分比，默认值0.46
         * */
        if (this.props.cStyle && JSON.parse(this.props.cStyle).resizeMark && JSON.parse(this.props.cStyle).resizeMark === 'true') {
            let rate = JSON.parse(this.props.cStyle).resizeRate ? parseFloat(JSON.parse(this.props.cStyle).resizeRate) : 0.46;
            let width = document.documentElement.clientWidth * rate;
            this.setState({
                sigWidth: width - 24 //左右有空白, 各12
            });
        }
    }

    componentDidMount() {
        if (this.props.model)
            this.props.model.addListener(this);
    }

    componentWillUnmount() {
        if (this.props.model)
            this.props.model.removeListener(this);
    }

    handleLoad() {
        const tempSrc = this.sigCanvas.toDataURL("image/jpeg");

        localStorage.setItem("savedImageData", tempSrc);
        var data = FormData.toFormData(tempSrc, 'signature.jpeg');

        let context = cb.rest.AppContext;
        let action = '/upload?token=' + context.token;

        fetch(action, {
            method: 'POST',
            body: data
        })
            .then(response => response.json())
            .catch(error => console.error('Error:', error))
            .then(response => {
                this.setState({
                    sigurl: this.url + response.data
                });
                if (this.props.model) {
                    this.props.model.setValue(this.state.sigurl, true);
                }
                cb.utils.alert("签名保存成功", 'success')
            });


    }
    handleClick() {
        this.sigCanvas.clear();
    }
    handleReadOnly() {
        this.setState({
            readOnly: true
        })
    }

    render() {
        //cShowCaption="签名区"
        const { cShowCaption } = this.props;
        const { sigWidth } = this.state;
        const title = !this.state.readOnly && this.state.bIsNull === false && cShowCaption ? <label><Icon type='star' />{cShowCaption}</label> : <label>{cShowCaption}</label>;
        let control = (cShowCaption ? <Label title={title} /> : null);

        if (this.state.readOnly)
            return (
                <div>
                    <img id="copySig" src={this.state.sigurl}></img>
                </div>
            )
        else
            return (
                <div className="sig-wrapper">
                    {control}
                    <div className="sig-pad">
                        <SignatureCanvas ref={(ref) => { this.sigCanvas = ref }}
                            penColor='black'
                            canvasProps={{ width: sigWidth, height: 368, className: 'sig-canvas' }}
                            backgroundColor='#eee' >
                        </SignatureCanvas>
                        <div className="sig-handle">
                            <span className="sig-clear" onClick={() => this.handleClick()}>

                            </span>
                            <span className="sig-save" onClick={() => this.handleLoad()}>

                            </span>
                            {/* <Button onClick={() => this.handleReadOnly()}>ReadOnly</Button> */}
                        </div>
                        <p className="sig-warn">请核对以上信息是否正确，并确认房间内设备是否完好，配套物品请勿带走！若无问题请签字确认，谢谢！</p>
                        {/* <img id="copySig" src={this.state.sigurl}></img> */}
                    </div>
                </div>
            )
    }
}

export default SigCanvas;


// WEBPACK FOOTER //
// ./src/yxyweb/common/components/basic/sigCanvas.jsx